// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__e3JHL","fadeIn":"styles_fadeIn__E5jLX"};